import { ApiError } from '@/shared/api/client';

/**
 * Whether an API failure means this session is over or no longer complete:
 * signed out or expired (401/419), or sent back to the MFA step. A running
 * guide stops at once — before the shell gives way to the sign-in or the MFA
 * screen, where guidance must not exist.
 */
export function endsTheSession(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;

  return (
    error.status === 401 ||
    error.status === 419 ||
    error.isUnauthenticated ||
    error.code === 'MFA_CHALLENGE_REQUIRED' ||
    error.code === 'MFA_ENROLMENT_REQUIRED'
  );
}
